import Grid from "@material-ui/core/Grid";
import Paper from "@material-ui/core/Paper";
import React, { useEffect, useState } from "react";

import { ErrorModal } from "@/components/shared/modal/error-modal";
import { Outlet } from "react-router-dom";
import { TableVendors } from "./components/VendorsDataTable/TableVendors";
import { useVendorsContext } from "./context/VendorsContext";
import { getVendors } from "./repositories/VendorsRepository";

export const Vendors = () => {
	const { state, actions } = useVendorsContext();
	const [isLoading, setIsLoading] = useState(true);

	const [fetchDataError, setFetchDataError] = useState<string | null>(null);

	const getVendorsFromAPI = async () => {
		setIsLoading(true);
		try {
			const { ok, vendors } = await getVendors();

			if (ok) {
				actions.setVendors(vendors);
				setIsLoading(false);
			}
		} catch (e: any) {
			setFetchDataError(e);
		}
	};

	useEffect(() => {
		getVendorsFromAPI();
	}, []);
	if (state.vendors) {
		return (
			<>
				<Grid container justifyContent="center" alignItems="center">
					<Grid item md={12} xs={12} style={{ margin: "20px" }}>
						<Paper
							elevation={1}
							style={{
								width: "100%",
								padding: "10px 0 50px",
								borderRadius: "0.75rem",
							}}
						>
							<TableVendors
								isLoading={isLoading}
								getVendorsFromAPI={getVendorsFromAPI}
							/>
						</Paper>
						<Outlet />
					</Grid>
				</Grid>
				<ErrorModal
					onHide={() => setFetchDataError(null)}
					error={fetchDataError}
				/>
			</>
		);
	}
	return <></>;
};
